<template>
    <b-modal
        id="show-skills"
        :title="$t('skill_tree.view_skills')"
        modal-class="apprentice-default-modal">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="skillsIn">
            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit"
                        v-b-modal="'update-skill' + data.item.id"
                        variant="primary-icon-only">
                    </b-button>

                    <b-button
                        class="btn-remove"
                        variant="danger-icon-only"
                        @click="deleteSkill(data.item.id)">
                    </b-button>

                    <skill-update-modal-component :skill-in="data.item"></skill-update-modal-component>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
import { ords } from '../../../../app';

export default {
    name: 'design-2021-skill-show-modal-component',
    props: ['skillsIn'],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        deleteSkill(id) {
            this.alert.saving();

            this.axios.delete(this.routes.skillsDelete(id)).then(
                (response) => {
                    ords.use('skill').remove(id);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
